import React from "react";
import {
    border,
    heading, infoGraphic,
    mHealthDescription,
    wrapper
} from "@/components/mhealth-studio/what-is-mhealth/styles/what-is-mhealth";
import {useTranslation} from "react-i18next";

const WhatIsMhealth: React.FC = () => {
    const {t} = useTranslation();

    return (
        <section>
            <div className={wrapper}>
                <div className={"tablet:mb-8 mobile:mb-2"}>
                <h2 className={heading}>WHAT IS <span className={"font-bold"}>MHEALTH STUDIO?</span></h2>
                    <hr className={border}/>
                </div>
                <p className={mHealthDescription}><span className={"font-bold"}>mHealth Studio</span>{t("mhealth.what-is-mhealth-studio.studio")}</p>
                <p className={mHealthDescription}><span className={"font-bold"}>mHealth Studio App</span>{t("mhealth.what-is-mhealth-studio.app")}</p>
                <p className={mHealthDescription}><span className={"font-bold"}>mHealth Studio Cloud</span>{t("mhealth.what-is-mhealth-studio.cloud")}</p>
            </div>
            <div className={"tablet:block mobile:hidden"}>
                <img className={infoGraphic} alt={"Patient data management tool infographic"} src={"/assets/images/mhealth/what-is-mhealth/patient-data-management-tool-lg.png"}/>
            </div>
            <div className={"mobile:block tablet:hidden"}>
                <img className={infoGraphic} alt={"Patient data management tool infographic"} src={"/assets/images/mhealth/what-is-mhealth/patient-data-management-tool-mobile.png"}/>
            </div>
        </section>
    )
}

export default WhatIsMhealth
